import { render, staticRenderFns } from "./template_sidebar.vue?vue&type=template&id=27f6997f&scoped=true&"
import script from "./template_sidebar.vue?vue&type=script&lang=js&"
export * from "./template_sidebar.vue?vue&type=script&lang=js&"
import style0 from "./template_sidebar.vue?vue&type=style&index=0&id=27f6997f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f6997f",
  null
  
)

export default component.exports